/**
 * Created by Mike Naughton on 8/30/17.
 *
 * Displays a large tap area from which users can upload images.
 */

import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import velocity from "velocity-animate";
import viewTemplate from "views/documents/ImageUploadView";

var ImageUploadView = Backbone.View.extend({
  className: "file-edit",

  tagName: "div",

  events: {
    "click td": function () {
      if (this._appearance !== "progress") {
        this.getFileControl().click();
      }
    },

    "change .file": function () {
      var files = this.getFileControl()[0].files;

      if (files && files.length) {
        this.commit();
        this.trigger("select-image", files[0], this.options.model);
      } else {
        this.trigger("cancel-image");
      }
    },
  },

  template: viewTemplate,

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {string} [options.appearance] The view state. One of "progress", "done", "default"
   * @param {Document} options.model The model to update.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      appearance: "default",
    });

    this.render();
    this.setAppearance(options.appearance, true);
  },

  render: function () {
    this.$el.html(this.template());
    this.$containers = this.$(".drag-drop-container > div");
    this.delegateEvents();

    return this;
  },

  /**
   * Sets the appearance state map.
   * @param {string} appearance The identifier of appearance to set.
   * @param {Boolean} [immediate] True to perform the transition immediately.
   */
  setAppearance: function (appearance, immediate) {
    var showContainers = [];
    var hideContainers = [];

    this._appearance = appearance;

    this.$containers.each(function () {
      var $el = $(this);

      if ($el.hasClass(appearance)) {
        showContainers.push(this);
      } else {
        hideContainers.push(this);
      }
    });

    if (immediate) {
      $(hideContainers).css("opacity", 0);
      $(showContainers).css("opacity", 1);
    } else {
      velocity(
        hideContainers,
        {
          opacity: 0,
        },
        {
          duration: 400,
          queue: false,
        }
      );
      velocity(
        showContainers,
        {
          opacity: 1,
        },
        {
          duration: 400,
          queue: false,
        }
      );
    }
  },

  /**
   * Sets the model
   * @param model The model to set.
   */
  setModel: function (model) {
    this.options.model = model;
  },

  /**
   * Commit the changes to the model.
   */
  commit: function () {
    var filename = this.getFileControl().val();

    filename = filename.replace(/^.*(\\|\/|:)/, "");

    this.options.model.set("Name", filename || "file");
  },

  /**
   * Get a reference to the file tag associated with this view.
   * @return {jquery} The file tag.
   */
  getFileControl: function () {
    return this.$(".file");
  },

  /**
   * Get a reference to the URL tag associated with this view.
   * @return {jquery} The URL tag.
   */
  getUrlControl: function () {
    return null;
  },

  /**
   * Gets a value indicating whether or not the user has elected to create a file document (vs a URL document)
   * @return {Boolean} True if the user is creating a file, otherwise false.
   */
  isFileType: function () {
    return true;
  },
});

export default ImageUploadView;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/documents/ImageUploadView.js
// module id = 899
// module chunks = 1